// What an on-stop authorisation history row records (Extension to Customer on Stop, Oct 2026).
// Mirrors TMSWeb.Common.Constants.OnStopAuthorisationActions - the values are stored on each row,
// so the two must stay in step.
export enum OnStopAuthorisationActions {
  authorised = 'Authorised',
  withdrawn = 'Withdrawn',
}

// An action as a person reads it, for the authorisation history list.
export function onStopAuthorisationActionName(action: string | undefined | null): string {
  switch (action) {
    case OnStopAuthorisationActions.authorised:
      return $localize`Authorised`;
    case OnStopAuthorisationActions.withdrawn:
      return $localize`Withdrawn`;
    default:
      // Anything unrecognised shows as stored rather than vanishing.
      return action ?? '';
  }
}
